import React, { Component } from 'react'
import axios from 'axios';
import {Link} from 'react-router-dom'
class EventBoxs2 extends Component {

    componentDidMount() {
        axios.get('http://kancelaria-podatkowa.com/wp-json/wp/v2/pages/5/')
            .then(res => this.setState({
                dataEvents: [
                    {
                        id: 1,
                        classicon: 'icon-rounded clipboard',
                        title: res.data.acf.title_service_4,
                        description: res.data.acf.text_service_4, 
                    },
                    {
                        id: 2,
                        classicon: 'icon-rounded line-chart',
                        title: res.data.acf.title_service_5,
                        description: res.data.acf.text_service_5,
                    },
                    {
                        id: 3,
                        classicon: 'icon-rounded clock',
                        title: res.data.acf.title_service_6,
                        description: res.data.acf.text_service_6,
                    },
                ]
            }))
            .catch(err => console.log(err));
    };


    constructor(props) {
        super(props);
        this.state = {
            dataEvents: [
                {
                    id: 4,
                    classicon: 'icon-rounded magic',
                    title: 'Estate Planning',
                    description: 'Donec lacinia mi rutrum sagittis consequat. Donec sagittis, tellus sodales sollicitudin commodo',
                },
                {
                    id: 5,
                    classicon: 'icon-rounded artboard',
                    title: 'Retirement Planning',
                    description: 'Donec lacinia mi rutrum sagittis consequat. Donec sagittis, tellus sodales sollicitudin commodo',
                },
                {
                    id: 6,
                    classicon: 'icon-rounded global',
                    title: 'Business Planning',
                    description: 'Donec lacinia mi rutrum sagittis consequat. Donec sagittis, tellus sodales sollicitudin commodo',
                },
            ]
        }
    }
    
    render() {
        return (
            <div className="row">
                {
                    this.state.dataEvents.map(data => (
                        <div className="col-md-4" key={data.id}>
                            <div className="iconbox-item">
                                <div className="iconbox style1">
                                    <div className="box-header">
                                        <div className={data.classicon}>
                                            
                                        </div>
                                        {/* <!-- /.icon-rounded --> */}
                                        <div className="box-title">
                                            <Link to="#" title="">{data.title}</Link>
                                        </div>
                                        {/* <!-- /.box-title --> */}
                                        </div>
                                        {/* <!-- /.box-header --> */}
                                    <div className="box-content">{data.description}</div>
                                    {/* <!-- /.box-content --> */}
                                </div>
                                 {/* <!-- /.iconbox --> */}
						    </div>
                            {/* <!-- /.iconbox-item --> */}
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default EventBoxs2;